export default __webpack_public_path__ + "static/media/10_2.8de1efd6.png";